<template>
  <v-app>
    <!--
    <v-app-bar
      app
      color="primary"
      dark
    >
    </v-app-bar>-->

   
    <v-main v-if="gotPackageData">
    
      <router-view></router-view>
    </v-main>
    <loading-screen/>
    <stage-navigator/>
    
  </v-app>
</template>

<script>

import axios from 'axios'
import config from '../config.json'
import LoadingScreen from './components/LoadingScreen.vue'
import StageNavigator from './components/Stages/StageNavigator.vue'
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

export default {
  name: 'App',

  components: {
    LoadingScreen,
    StageNavigator
  },
  computed: {
     ...mapState("sessionState", [
      "package"
    ])

  },

  data: () => ({

    gotPackageData : false
    //
  }),
  mounted: function () {

    const appInsights = new ApplicationInsights({ config: {
      connectionString: 'InstrumentationKey=e8fb527e-b0fa-4f7e-b874-cd3bec7b4ccb;IngestionEndpoint=https://uksouth-0.in.applicationinsights.azure.com/'
      /* ...Other Configuration Options... */
    } });
    appInsights.loadAppInsights();
    appInsights.trackPageView();

    if(this.$route.params.packageid != null)
    {
      var url = config.platformEndpoints.coreblobstorage + "packagesv2/" +   this.$route.params.packageid + ".json";
      axios.get(url)
      .then((response) => {

        
        this.SetPackageData({id : this.$route.params.packageid, data : response.data});
        this.gotPackageData = true;
        this.SetStageDataIfRequired();
      })
      .catch((error) => {
        this.SetLinkAsInvalid();
      })
    }
  },
  methods : {

    ...mapMutations("sessionState", [
        "SetPackageData",
        "SetStageData",
        "SetLinkAsInvalid"
    ]),
    SetStageDataIfRequired()
    {
      if(this.$route.params.stageid != null)
      {
        var stage = this.package.stages.filter(item => item.id == this.$route.params.stageid);

        if(stage.length > 0)
        {
          this.SetStageData(stage[0]);
        }
      }
    }
  },
  watch : {

    $route (to, from){
      this.SetStageDataIfRequired();
    }

  }
};
</script>

<style>

    html { overflow-y: auto }
    
    .competition-language-select {
      width: 100%;
      text-align: right;
    }

    .checkbox-promo label {
      font-size: 12px;
      line-height: 1.3 !important;
    }

</style>
